import React from 'react'
import Fav from '../../../assets/images/leading-bg.png'

export default function LeadBanner() {
    const selectCity = localStorage.getItem('selectedCity');
    return (
        <section className="section-equal-padding uk-scrollspy-inview"
            style={{ backgroundImage: `url(${Fav})`, backgroundRepeat: 'no-repeat', backgroundSize: "cover" }}
            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
            <div className="container">
                <div className="slider-content text-center w-100" style={{maxWidth:'100%'}}>
                    <h1>{selectCity}</h1>
                    <p>Experience the vibrant spirit of {selectCity} with MySittiVacation! Dive into the heart of Texas music,
                        savor the local flavors at renowned food trucks, and explore the scenic trails around Lady Bird
                        Lake. Your solo adventure to {selectCity} starts here. Book now and let the city’s unique culture
                        captivate you!
                    </p>
                </div>
            </div>
        </section>
    )
}
